var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53244 0.766515L5.00447 4.30182L8.47651 0.766515C8.8255 0.411162 9.38926 0.411162 9.73825 0.766515C10.0872 1.12187 10.0872 1.6959 9.73825 2.05125L5.63087 6.23349C5.28188 6.58884 4.71812 6.58884 4.36913 6.23349L0.261745 2.05125C-0.0872483 1.6959 -0.0872483 1.12187 0.261745 0.766515C0.610738 0.420273 1.18345 0.411162 1.53244 0.766515Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelect);
export default __webpack_public_path__ + "static/media/arrow_select.f8da15d0145e185ad54846e9fca865cc.svg";
export { ForwardRef as ReactComponent };